import { render, staticRenderFns } from "./patienthist.vue?vue&type=template&id=1e35fb45&"
import script from "./patienthist.vue?vue&type=script&lang=js&"
export * from "./patienthist.vue?vue&type=script&lang=js&"
import style0 from "./patienthist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports